export const decodeEmissionFactor = (entity) => ({
    created: new Date(entity.created),
    emissionFactorType: entity.emission_factor_type,
    id: entity.emission_factor_id,
    projectId: entity.project_id,
    value: entity.value
});
export const encodeEmissionFactor = (lineItem) => ({
    created: lineItem.created,
    emission_factor_id: lineItem.id,
    emission_factor_type: lineItem.emissionFactorType,
    project_id: lineItem.projectId,
    value: lineItem.value
});
